module.exports = __webpack_public_path__ + "8949eb215b76cdd97ece40e47555609b.fbx";